import React from "react";
import { motion } from "framer-motion";
import { fadeUp, slideLeft } from "../../animations/variants";

import { useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import { ourApproachMaria } from "i18n/about";

import {
  Search,
  Lightbulb,
  ClipboardList,
  Handshake,
  BarChart3,
} from "lucide-react";
const OurApproach = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = ourApproachMaria[lang];

  const consults = t.steps;

  const icons = [Search, Lightbulb, ClipboardList, Handshake, BarChart3];

  const navigate = useNavigate();
  return (
    <section className="py-20 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="text-left max-w-8xl mx-auto my-16"
        >
          <h2 className="text-4xl md:text-6xl font-[Crimson] text-reddark leading-tight mb-6 font-normal text-center">
            {t.title}
          </h2>
          <div className="w-24 h-[2px] bg-reddark mx-auto mt-8 mb-8" />

          <p className="space-y-8 text-[#111] md:text-lg leading-relaxed">
            {t.description}
          </p>
          {/* <p className="italic text-[#9b7b62] mb-3">{t.description}</p> */}
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="max-w-6xl mx-auto text-left "
        >
          {" "}
          {consults.map((step, index) => {
            const Icon = icons[index];

            return (
              <motion.div
                key={index}
                variants={slideLeft}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                className={`
        border border-gray-300
        bg-white
        shadow-sm
        p-6 md:p-12
        my-4

        ${index === 0 ? "md:max-w-[1000px] md:mr-20" : ""}
        ${index === 1 ? "md:max-w-[1000px] md:ml-24 md:-mt-10" : ""}
        ${index === 2 ? "md:max-w-[1000px] md:mr-20 md:-mt-10" : ""}
        ${index === 3 ? "md:max-w-[1000px] md:ml-24 md:-mt-10" : ""}
        ${index === 4 ? "md:max-w-[1000px] md:mr-20 md:-mt-10" : ""}
      `}
              >
                <h3 className="flex items-center gap-4 text-2xl md:text-3xl font-[Crimson] text-reddark mb-6">
                  <div className="w-12 h-12 rounded-full bg-reddark text-white flex items-center justify-center shrink-0">
                    <Icon size={22} />
                  </div>

                  <div>
                    {/* <div className="text-sm font-sans font-semibold text-gray-500">
                      {step.number}
                    </div> */}

                    <div>{step.title}</div>
                  </div>
                </h3>

                <p className="text-gray-700 text-base md:text-lg leading-8">
                  {step.description}
                </p>
              </motion.div>
            );
          })}
        </motion.div>

        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="mt-14 border-l-4 border-reddark pl-6 italic text-gray-700 text-lg leading-8"
        >
          {t.closing}
        </motion.div>
      </div>
    </section>
  );
};

export default OurApproach;
